<template>
  <div class="ProductDetalisDemo">
    <div class="proItem " >
      <img :src="img" class="itemPic">
      <div class="itemText">
        <p class="itemTitle textOver">{{info.productName}}</p>
        <p class="itemCmp textOver">{{ info.createCorpName}}</p>
        <p class="itemPrice">￥ {{info.price / 100| PriceFilter}}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default() {
        return{};
      },
    },
  },
  computed: {
    img() {
      return this.info.thumb && this.info.thumb.length ? this.info.thumb[0].img : '';
    },
  },
}
</script>
<style lang="scss" scoped>
.proItem{
  width: 9.36rem;
  height: 2.666667rem;
  background-color: #fff;
  border-radius: .093333rem;
  margin-bottom: .32rem;
  display: flex;
  .itemPic{
    width: 2.666667rem;
    height: 2.666667rem;
    border-radius: .093333rem 0 0 .093333rem;
    display: inline-block;
    vertical-align: middle;
  }
  .itemText{
    display: inline-block;
    vertical-align: middle;
    flex: 1;
    padding: .32rem .253333rem;
    .itemTitle{
      color: rgb(51, 51, 51);
      font-size: .453333rem;
      font-weight: bold;
      width: 5.866667rem;
    }
    .itemCmp{
      font-size: .32rem;
      color: rgb(102, 102, 102);
      margin-top: .24rem;
      width: 5.866667rem;
    }
    .itemPrice{
      color: rgb(218, 37, 44);
      font-size: .4rem;
      font-weight: bold;
      margin-top: .32rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personal/orderComponents/ProductDetalisDemo.vue